import { CLASS_NAMES } from '../../utils/constants'
import Moveable from './Moveable'

export default class Fallable extends Moveable {
  constructor(props) {
    super(props)
    this.isFalling = 0 // increment on each loop that the element is falling
    this.freeze = false // when true, prevents the object to be affected by gravity loop.
  }

  canFallDown() {
    const nextPos = { x: this.position.x, y: this.position.y + 1 }
    const destinationInBounds = this.level.isDestinationInBounds(nextPos.x, nextPos.y)
    const destinationElement = destinationInBounds && this.level.getObjectAt(nextPos.x, nextPos.y)
    const destinationIsEmpty = this.level.isDestinationEmpty(nextPos.x, nextPos.y) || destinationElement?.isClass(CLASS_NAMES.EXPLOSION)
    const destinationIsCrushable = destinationElement.isCrushable && this.isFalling
    const canFall = destinationIsEmpty || destinationIsCrushable

    return canFall
  }
  canRollTo(x, y) {
    const nextPos = { x, y }
    const destinationInBounds = this.level.isDestinationInBounds(nextPos.x, nextPos.y)
    const pathElement = destinationInBounds && this.level.getObjectAt(nextPos.x, this.position.y)
    const pathClear = destinationInBounds && this.level.objectIsEmpty(pathElement)
    const destinationElement = destinationInBounds && this.level.getObjectAt(nextPos.x, nextPos.y)
    const destinationIsEmpty = this.level.objectIsEmpty(destinationElement)
    const restingElement = destinationInBounds && this.level.getObjectAt(this.position.x, this.position.y + 1)
    const canRest = !this.level.isDestinationEmpty(this.position.x, this.position.y + 1) && restingElement.isFlat
    const canRoll = destinationInBounds && destinationIsEmpty && pathClear && !canRest && restingElement && !restingElement.isFalling

    return canRoll
  }
  canFallRight() {
    return !this.canFallDown() && this.canRollTo(this.position.x + 1, this.position.y + 1)
  }
  canFallLeft() {
    return !this.canFallDown() && this.canRollTo(this.position.x - 1, this.position.y + 1)
  }
}

Fallable.className = CLASS_NAMES.FALLABLE
